<template>
  <div class="tracking">
    <h1>Event Tracking</h1>
    <input type="text" placeholder="Search.." v-model="stringSearch" />
    <select @change="searchByFilter" v-model="filterCode">
      <option :value="el.evn_code" v-for="(el, i) in eventList" :key="i">
        {{ el.evn_name }}
      </option>
    </select>
    <DropDown
      :options="users"
      :displayKey="'fullName'"
      :isOpened="isOpened"
      @set-opened="handleSetOpened"
      @get-value="handleGetValue"
      :id="0"
      :placeholder="'Select Users'"
      class="dropdown"
    />
    <div class="wrapper">
      <span class="single-event">
        <span>Time :</span>
        <span>Event Code :</span>
        <span>Event Name :</span>
        <span>User ID :</span>
        <span>Full Name :</span>
        <span>Email :</span>
        <span> Data :</span>
      </span>
      <div class="single-event" v-for="(event, i) in events" :key="i">
        <span> {{ event.utr_time }}, </span>
        <span>
          {{ event.evn_code }}
        </span>
        <span>
          {{ event.evn_name }}
        </span>
        <span>
          {{ event.usr_id }}
        </span>
        <span> {{ event.usr_firstname }} {{ event.usr_lastname }} </span>
        <span>
          {{ event.usr_email }}
        </span>
        <span> {{ event.utr_data ? event.utr_data : "/" }} </span>
      </div>
      <div class="pagination">
        <span> Total: {{ totalCount }} </span>
        <div class="current-display-num">
          Currently Displaying: {{ currentlyDisplaying }} out of
          {{ totalCount }}
        </div>
        <div class="arrows">
          <button @click="offsetAddition = '-'">&#60; PREVOUS</button>
          <button @click="offsetAddition = '+'">NEXT &#62;</button>
        </div>
      </div>
    </div>
    <button @click="downloadTracking">Download CSV</button>
  </div>
</template>

<script>
import DropDown from "@/components/list-of-attendees/DropDown.vue";
import api from "@/api";
export default {
  components: {
    DropDown,
  },
  data() {
    return {
      totalCount: null,
      totalPageNumber: null,
      offset: 0,
      events: [],
      offsetAddition: "",
      eventList: [],
      filterCode: "all",
      stringSearch: "",
      isOpened: false,
      users: [],
      selectedUsers: [],
      selectedUsersId: [],
    };
  },
  computed: {
    filter() {
      let filter = {
        code: this.filterCode == "all" ? "" : this.filterCode,
        usr_ids: this.selectedUsersId,
        search: this.stringSearch,
      };
      filter = JSON.stringify(filter);
      return filter;
    },
    currentlyDisplaying() {
      if (this.events.length < 10) return this.totalCount;
      else if (this.events.length == 10) return this.offset + 10;
      return "";
    },
  },
  watch: {
    offsetAddition(val) {
      if (val == "+" && this.offset < this.totalCount) {
        this.offset += 10;
      }
      if (val == "-" && this.offset > 0) {
        this.offset -= 10;
      }
      this.getAllTracking({
        limit: 10,
        offset: this.offset,
        filter: this.filter,
      });
      this.offsetAddition = "";
    },
    stringSearch(val) {
      if (val) this.offset = 0;
    },
    filterCode(val) {
      if (val) this.offset = 0;
    },
    filter(val) {
      if (val) this.searchByFilter();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async getAllTrackingCount(params) {
      try {
        const res = await api.getAllTrackingCount(params);
        this.totalCount = res.data.count;
        this.totalPageNumber = Math.ceil(this.totalCount / 10);
      } catch (error) {
        console.log(error);
      }
    },
    async getAllTracking(params) {
      try {
        const res = await api.getAllTracking(params);
        this.events = res.data.data;
        console.log(this.events,'ovo mi treba');
      } catch (error) {
        console.log(error);
      }
    },
    async getEvents() {
      try {
        const res = await api.getEvents();
        this.eventList = res.data.data;
        console.log(this.eventList,12312)
        this.eventList.unshift({ evn_code: "all", evn_name: "All" });
      } catch (error) {
        console.log(error);
      }
    },
    async searchByFilter() {
      try {
        this.getAllTrackingCount({
          limit: 10,
          offset: this.offset,
          filter: this.filter,
        });
        this.getAllTracking({
          limit: 10,
          offset: this.offset,
          filter: this.filter,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async downloadTracking() {
      try {
        const res = await api.downloadTracking({ filter: this.filter });
        console.log(res.data);
        const blob = new Blob([res.data], { type: "application/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Virtual_Fair_Event_Tracking.csv");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.log(error);
      }
    },
    async getUsers() {
      try {
        const res = await api.getUsers({ limit: 999, offset: 0 });
        this.users = res.data.result.map((user) => {
          return {
            ...user,
            fullName: user.usr_firstname + " " + user.usr_lastname,
          };
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    handleGetValue(users) {
      this.selectedUsersId = [];
      this.selectedUsers = users;
      this.selectedUsers.forEach((el) => {
        this.selectedUsersId.push(el.usr_id);
      });
      console.log(this.selectedUsersId);
      this.searchByFilter();
    },
    handleSetOpened() {
      this.isOpened = !this.isOpened;
    },

    init() {
      this.getUsers();
      this.getEvents();
      this.getAllTrackingCount();
      this.getAllTracking({ limit: 10, offset: this.offset });
    },
  },
};
</script>

<style scoped lang='scss'>
.tracking {
  margin: 40px;
  h1 {
    text-align: center;
    margin: 0 0 30px 0;
  }
  input {
    width: 300px;
    margin: 0 calc(100% - 300px) 30px 0;
    outline: none;
  }
  .dropdown,
  select {
    display: block;
    margin: 20px 100% 0 0;
  }
  .wrapper {
    .single-event {
      margin: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid black;
      padding: 0 0 10px 0;
      span {
        width: 200px;
        display: inline-block;
        text-align: center;
      }
    }
    .pagination {
      margin: 50px 0;
      .current-display-num {
        margin: 20px 0;
      }
    }
    .arrows {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 50px;
        // font-size: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>